import React from "react";
import { Outlet } from "react-router-dom";
import Container from "@mui/material/Container";

const AuthLayout: React.FC = () => {
  return (
    <Container
      maxWidth="xxl"
      sx={{
        bgcolor: "white",
        padding: "0 !important",
      }}
    >
      <Outlet />
    </Container>
  );
};

export default AuthLayout;
